import { Button, Col, DatePicker, Form, Input, Select } from 'antd'
import styles from './styles.module.scss'
import { v4 as uuidv4 } from 'uuid'
import { OPTIONS_STATUS_NOTIFICATION } from '../../configData'
import { removeVietnameseTones } from '../../config-func'
import { debounce } from 'lodash'
const { RangePicker } = DatePicker
const { Option } = Select

const SearchForm = ({ fetchData, handleSearch, setFilters }) => {
  const [form] = Form.useForm()

  const handleReset = debounce(() => {
    setFilters({ currentPage: 1, pageSize: 10, reset: uuidv4() })
    form.resetFields()
    // fetchData()
  }, 300)

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSearch}
      style={{ marginTop: 10 }}
      onValuesChange={(value, allValues) => {
        setFilters((prev) => ({ ...prev, ...allValues }))
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '16px',
          alignItems: 'center'
        }}
      >
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Title" name="title">
            <Input
              placeholder="Nhập title"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'title',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
        </div>
        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Trạng thái" name="status">
            <Select
              style={{ width: '100%' }}
              placeholder="Chọn trạng thái"
              defaultValue="Tất cả"
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase();
                const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                return optionValue.includes(inputValue);
              }}
            >
              <Option value="">Tất cả</Option>
              {OPTIONS_STATUS_NOTIFICATION.map((item, idx) => (
                <Option key={idx} value={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
          <Form.Item label="Thời gian" name="date">
            <RangePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
          </Form.Item>
        </div>
        <div
          style={{
            display: 'flex',
            gap: '8px',
            justifyContent: 'flex-end',
            flex: '1 1 200px',
            minWidth: '200px'
          }}
        >
          <Button onClick={handleReset}>Đặt lại</Button>
          <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }}>
            Tìm kiếm
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default SearchForm
